import { PersistentFormControl, PersistentFormGroup } from '@utility/persistent-forms';

export class SiteServicesPatientPaceOptionsFormGroup extends PersistentFormGroup<{
    allowPPInvitations: PersistentFormControl<boolean | null>;
}> {
    constructor() {
        super({
            allowPPInvitations: new PersistentFormControl<boolean | null>(null),
        });
    }
}
